import { BASE_URL } from "../../config";

import {
    UPDATE_ORDERS,
    GET_BOOKED_ORDERS,
    FORCE_UPDATE_ORDER,
    UPDATE_ORDER,
} from "./bookedOrders.actionsTypes";
import axios from "axios";

import delivery from "../../components/delivery/delivery";
import Notifier from "../../components/message/Notifier";
import { ERRORS } from "../../config/constants";

const registerSessionListeners = (dispatch) => {
    if (delivery.ordersListenersRegistered) {
        return;
    }
    let orders = [];
    delivery.orderUpdated((order) => {
        if (order.forceUpdate) {
            dispatch(getOrder(order, forceUpdateOrder));
        }
        orders.push(order);
    });
    delivery.disconnected((reason) => {
        if (-1 === ERRORS.forced_close.reason.indexOf(reason)) {
            Notifier.error(
                ERRORS.network_error.message,
                ERRORS.network_error.title,
                true
            );
        }
    });
    setInterval(() => {
        if (orders.length) {
            dispatch(updateOrders(orders));
            orders = [];
        }
    }, 5000);
    delivery.ordersListenersRegistered = true;
};

export const getBookedOrders = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}v2/order/book`).then((response) => {
            registerSessionListeners(dispatch);
            if (response.data) {
                dispatch({
                    type: GET_BOOKED_ORDERS,
                    orders: response.data,
                });
            }
        });
    };
};


export const cancelBookedOrderByApi = (id, order) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}order/cancel-book/${id}`, order).then((response) => {
            if (response.data) {
                dispatch(updateOrder(response.data));
                Notifier.success(
                    "_order_successfully_updated_",
                    "_order_updated_",
                );
            }
        });
    };
};

export const updateOrders = (orders) => {
    return {
        type: UPDATE_ORDERS,
        orders,
    };
};

export const updateOrder = (order) => {
    return {
        type: UPDATE_ORDER,
        order,
    };
};

export const getOrder = (order, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}order/${order.id}`).then((response) => {
            if (response.data && response.data.order) {
                if (order.hasOwnProperty("blink")) {
                    response.data.order.blink = order.blink;
                }
                dispatch(callback(response.data.order));
            }
        });
    };
};

export const forceUpdateOrder = (order) => {
    return {
        type: FORCE_UPDATE_ORDER,
        order,
    };
};
